/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerStatisticsListV2 = {
    type: 'array',
    contains: {
        type: 'PlayerStatisticsV2',
    },
} as const;
